import { Paper, Fade, Typography as MuiTypography } from '@mui/material';

import { makeStyles } from '@mui/styles';

import { Card } from '../../../cards';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette }) => ({
    root: {
      padding: spacing(1, 2),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      color({ status }) {
        switch (status) {
          case 'business':
            return palette.text.onMain;
          default:
            return palette.text.onContrasted;
        }
      },
      backgroundColor({ status }) {
        switch (status) {
          case 'success':
            return palette.status.success;
          case 'error':
            return palette.status.fail;
          case 'info':
            return palette.status.awaiting;
          case 'warning':
            return palette.status.retry;
          case 'business':
            return palette.brand.accent.option1;
          default:
            return palette.status.notStarted;
        }
      },

      '& a': {
        color: palette.text.onContrasted,
        '&:hover': {
          textDecoration: 'none',
          color: palette.text.onContrasted,
        },
      },
    },
  }),
  { classNamePrefix: 'DisclaimerMessage' }
);

export default function DisclaimerMessage({
  children = null,
  buttonLabel = 'OK',
  onClose = () => {},
  onExited = () => {},
  isOpen = false,
  status = 'default',
  closeButtonProps = {},
  ...otherProps
}) {
  const classes = useStyles({ status });

  return (
    <Fade in={isOpen} timeout={500} unmountOnExit onExited={onExited} {...otherProps}>
      <Paper className={classes.root}>
        <MuiTypography
          component="span"
          sx={{
            color: 'inherit',
          }}
        >
          {children}
        </MuiTypography>
        {buttonLabel && onClose && (
          <Card.ActionButton
            color="inherit"
            onClick={onClose}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...closeButtonProps}
          >
            {buttonLabel}
          </Card.ActionButton>
        )}
      </Paper>
    </Fade>
  );
}
